import type { PositionData } from '@ori/analytics-data';

import { ContentTypes, Header, RequestMethod } from '~/models';

export const getHttpRequestSettings: <T extends PositionData & object>(
  data?: T,
  method?: RequestMethod,
) => RequestInit = (data, method = RequestMethod.Get) => {
  const headers: HeadersInit = {
    [Header.ContentType]: ContentTypes.Json,
  };
  let body: BodyInit | undefined;
  if (data) {
    const { placement, ...finalData } = data;
    if (placement) {
      headers[Header.Placement] = placement;
    }
    const bodyValue = JSON.stringify(finalData);
    body = bodyValue === '{}' ? undefined : bodyValue;
  }

  return {
    credentials: 'same-origin',
    headers,
    method,
    ...(method === RequestMethod.Post && Boolean(body) && { body }),
  };
};
